import React from 'react';
import SimpleModal from '@/shadcn/components/SimpleModal.tsx';

/*
 * "Activate this output?" — the frame SimpleModal was drawn from
 * (S311lGXE6JSyTnNAXHmtR7, page "dlvr.it / simple modal", 30031-3207), so this
 * is the kit's copy rather than a restatement of it.
 *
 * It is a whole modal and not a panel: it used to have a contentOnly mode so the
 * connect dialog could draw it as one of its own screens, which meant legacy
 * markup inside that dialog's `.tw-root` and the layout that came with it. A
 * modal raised over the dialog costs nothing — ConnectSocialDialog is
 * deliberately non-modal so exactly this can happen.
 */
const ReactivateModal = (props) => {

    const cancel = () => {
        props.cancelAction(props.social);
    };

    return (
        <SimpleModal
            title="Activate this output?"
            description="Activate and restart posting to this social channel."
            confirmLabel="Activate"
            cancelLabel="Cancel"
            onConfirm={() => {
                props.activateSocial(props.social);
            }}
            onCancel={cancel}
            onClose={cancel}/>
    );

};

export default ReactivateModal;
